export var locales = ['en_US', 'fr_FR'];
export var defaultLocale = 'en_US';